import { render, staticRenderFns } from "./DeliveryZoneStatus.vue?vue&type=template&id=5f94cefa&scoped=true"
import script from "./DeliveryZoneStatus.vue?vue&type=script&lang=js"
export * from "./DeliveryZoneStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f94cefa",
  null
  
)

export default component.exports